import React, { useState, forwardRef, useEffect } from 'react'
import cx from 'classnames'
import style from './checkbox.module.scss'
import PropTypes from 'prop-types'
import { VegaIcon } from '../icon/Icon'

const VegaCheckbox = forwardRef(
	({ label, onClick, className, checked = false, disabled = false, name }, ref) => {
		const [isChecked, setCheck] = useState(checked)

		useEffect(() => {
			if (isChecked !== checked) {
				setCheck(checked)
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [checked])

		const handleClick = () => {
			if (!disabled) {
				setCheck(!isChecked)
				if (onClick) {
					onClick(!isChecked)
				}
			}
		}

		return (
			<div
				className={cx(style.checkbox, className, {
					[style.checked]: isChecked,
					[style.disabled]: disabled
				})}
				onClick={handleClick}
			>
				<VegaIcon name="check" />
				{label}
				<input
					ref={ref}
					name={name}
					checked={isChecked}
					className={style.hidden}
					type="checkbox"
					readOnly
				/>
			</div>
		)
	}
)

VegaCheckbox.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Label of the checkbox */
	label: PropTypes.string,
	/** Set action on click */
	onClick: PropTypes.func,
	/** Set checked state */
	checked: PropTypes.bool,
	/** Set disable state */
	disabled: PropTypes.bool,
	/** Name of input */
	name: PropTypes.string
}

export { VegaCheckbox }
